export default {
  "b2b.doplnkove-sluzby-grid.title": "Doplňkové služby",
  "b2b.doplnkove-sluzby-grid.add": "Přidat službu"
};
